import { useToast } from '@ordr-as/umami-react/toast';
import { useIntl } from 'react-intl';
import { PrintReceiptDtoTypeEnum } from '../../generated-api';
import { useMutatePrintReceipt } from './useReceiptApi';
import { useCallback, useMemo } from 'react';

const usePrintReceipt = (onSuccess: () => void = () => undefined) => {
  const { mutate: print, isPending } = useMutatePrintReceipt();
  const intl = useIntl();
  const toasts = useToast();

  const printReceipt = useCallback(
    (reference: string, placementId: number) => {
      print(
        { reference, printReceiptDto: { placementId, copies: 1, type: PrintReceiptDtoTypeEnum.SALES_RECEIPT } },
        {
          onSuccess: () => {
            if (!toasts.exists(placementId.toString())) {
              toasts.pushSuccess({
                id: placementId.toString(),
                message: <span>{intl.formatMessage({ id: 'receipt.print.success' })}</span>,
              });
              onSuccess();
            }
          },
          onError: () => {
            if (!toasts.exists(placementId.toString())) {
              toasts.pushError({
                id: placementId.toString(),
                message: <span>{intl.formatMessage({ id: 'receipt.print.error' })}</span>,
              });

              setTimeout(() => {
                toasts.remove(placementId.toString());
              }, 1000);
            }
          },
        }
      );
    },
    [intl, onSuccess, print, toasts]
  );

  return useMemo(
    () => ({
      printReceipt,
      isPending,
    }),
    [isPending, printReceipt]
  );
};

export default usePrintReceipt;
